
import translations from './SellerComment.translations'

export default {
  props: {
    comment: {
      type: String,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    shouldDisplayComment() {
      return !!this.comment
    },
  },
}
